import IAppConfig from "../models/AppConfig.interface";

export const AppConfig: IAppConfig = {
  applicationName: "WAHLOTTO",
  primaryColor: "#000",
  accentColor: "#fff",
  snackTransition: "fade",
};
